$(document).ready(function () {
    validateForms($("form.validate"));
});

window.login = function login(form) {
    if (!form.valid()) {
        return;
    }

    var validated = true;
    var values = [];
    var $inputs = form.find('input[name^="code_"]');
    var isEnterCodeShown = $(".enter-code-wrap").is(":visible");

    $inputs.each(function () {
        if ($(this).val() === '' || $(this).val().length === 0) {
            validated = false;
        } else {
            values.push($(this).val());
        }
    });

    if (!validated && isEnterCodeShown) {
        showAlert(ALERT_TYPE, {code: 400, message: "Enter the full code"});
        return false;
    }

    form.find(".final-code").val(values.join(['']));
    checkRecaptcha(form);

    $.ajax({
        type: 'POST',
        url: form.attr('action'),
        data: form.serialize(),
        timeout: 30000,
        dataType: 'json',
        success: function (response) {
            if (response.code === 210) {
                $(".login-form-wrap").hide();
                $(".enter-code-wrap").show();
            } else if (response.code === 200) {
                showAlert(ALERT_TYPE, response);
                setTimeout(function () {
                    window.location.href = response.data.redirectTo;
                }, 1000);
            } else {
                showAlert(ALERT_TYPE, response);
            }
        },
        error: function (error) {
            showAlert(ALERT_TYPE, {code: 400, message: error.responseText});
        }
    });
}

function checkRecaptcha(form) {
    if (typeof SITE_KEY === 'undefined' || SITE_KEY === "") {
        form.find("button[type=submit]").removeAttr("disabled");
    } else if (typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function () {
            grecaptcha.execute(SITE_KEY, {action: 'submit'}).then(function (token) {
                form.find("button[type=submit]").removeAttr("disabled");
                form.find(".g-recaptcha-response").val(token);

                setTimeout(function () {
                    checkRecaptcha(form);
                }, 90000)
            })
        });
    }
}

var ResRecaptchaLoaded = false;
var recaptchaInProgress = false;
$(document).on("mousedown touchstart change mouseenter", ".classicForm", function (e) {
    var form = $(this);
    initRecaptcha(form);
});

function initRecaptcha(form) {
    var $this = form;
    if (typeof SITE_KEY === 'undefined' || SITE_KEY === "") {
        checkRecaptcha(form);
        return;
    }

    if (form.length > 0 && form.find(".g-recaptcha-response").length === 1 && form.find(".g-recaptcha-response").val() === "") {
        if (!ResRecaptchaLoaded && !recaptchaInProgress) {
            recaptchaInProgress = true;
            $.getScript(`https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`)
                .done(function () {
                    checkRecaptcha(form);
                    ResRecaptchaLoaded = true;
                })
                .fail(function () {
                    recaptchaInProgress = false;
                });
        } else {
            checkRecaptcha(form);
        }
    }
}
